

import * as yup from 'yup';

export const userSchema = yup.object().shape({
    name: yup.string().matches(/^[A-Za-z\s]+$/, 'Full name must contain only letters').required('Full name is required'),
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
    password: yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
    phone: yup.string().matches(/^[0-9]+$/, 'Telephone number must contain only numbers').required('Contact number is required'),
    address: yup.string().required('Delivery address is required'),
})
